var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Flatfinder',{staticClass:"residential-flatfinder",attrs:{"value":_vm.flatfinders,"suggested":_vm.suggestedFlatfinder,"properties":_vm.properties}})
}
var staticRenderFns = []

export { render, staticRenderFns }